import React from 'react';
import { TableBody } from '@mui/material';
import { SelectAllRowsButton } from '../Table';
import { useAvTableV2Context } from './AvTableV2Provider';
import AvTableV2Row from './AvTableV2Row';

interface AvTableV2BodyProps {
  showSelectAllRowsButton: boolean;
  tableContainerRef: React.RefObject<HTMLDivElement | null>;
  clearSelect: () => void;
  setIsClickedAll: React.Dispatch<React.SetStateAction<boolean>>;
  isClickedAll: boolean;
  handleSelectAllRowsClick: () => void;
  enableActiveRowHighlighting?: boolean;
}

const AvTableV2Body = ({
  showSelectAllRowsButton,
  tableContainerRef,
  clearSelect,
  setIsClickedAll,
  isClickedAll,
  handleSelectAllRowsClick,
  enableActiveRowHighlighting,
}: AvTableV2BodyProps) => {
  const { table } = useAvTableV2Context();
  const columnOrderKey = table.getState().columnOrder.join('-');
  return (
    <TableBody>
      {showSelectAllRowsButton && (
        <SelectAllRowsButton
          width={tableContainerRef.current?.clientWidth}
          colspan={table.getVisibleLeafColumns().length}
          totalRows={table.getRowCount()}
          onClearSelection={clearSelect}
          onSelectAllRows={handleSelectAllRowsClick}
          currentPageRows={table.getRowModel().rows.length}
          setAllClicked={setIsClickedAll}
          isClickedAll={isClickedAll}
        />
      )}
      {table.getRowModel().rows.map(row => (
        <AvTableV2Row
          key={`${row.id}-${columnOrderKey}`}
          row={row}
          isSelected={row.getIsSelected()}
          isActive={row.getIsActive()}
          enableActiveRowHighlighting={enableActiveRowHighlighting}
        />
      ))}
    </TableBody>
  );
};

const MemoizedAvTableV2Body = React.memo(AvTableV2Body);

export default MemoizedAvTableV2Body;
